// extracted by mini-css-extract-plugin
export var blue = "_22-h";
export var brand = "_22-d";
export var darkGrey = "_22-g";
export var disabled = "_22-6";
export var disabledSubtle = "_22-7";
export var error = "_22-8";
export var green = "_22-i";
export var grey = "_22-f";
export var icon = "_22-0";
export var inherit = "_22-c";
export var lightGrey = "_22-e";
export var orange = "_22-k";
export var pink = "_22-m";
export var primary = "_22-1";
export var purple = "_22-n";
export var quaternary = "_22-4";
export var quinary = "_22-5";
export var red = "_22-l";
export var secondary = "_22-2";
export var success = "_22-b";
export var tertiary = "_22-3";
export var warning = "_22-9";
export var warningSecondary = "_22-a";
export var white = "_22-o";
export var yellow = "_22-j";